const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/integrations/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { requirePermission } from '@/lib/hooks/common/usePermissions';
const integrationsSchema = z.object({
  integration: z.custom<WorkIntegration_Keys>().optional(),
  oauthCredentialsId: z.number().optional(),
  integrationId: z.number().optional(),
  createInstance: z.string().optional(),
  instanceId: z.string().optional(),
  instanceUrl: z.string().optional(),
  callbackSource: z.string().optional()
});
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/integrations/')({
  validateSearch: zodValidator(integrationsSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: requirePermission('edit_integrations')
});